module.exports = __webpack_public_path__ + "media/site_templates/www.guttercleaning.biz/images/splash-9c16b7698d43a829f8068570c58dc267.jpg";